import Proxy from "./Proxy"

class CustomerProxy extends Proxy {
  constructor(parameters = {}) {
    super("customers", parameters)
  }

  allContacts(id, ...args) {
    return this.submit("get", `/${this.endpoint}/${id}/contacts/`, ...args)
  }

  updateContacts(id, items, ...args) {
    return this.submit(
      "post",
      `/${this.endpoint}/${id}/contacts/`,
      items,
      ...args
    )
  }

  allSupportContracts(id, ...args) {
    return this.submit(
      "get",
      `/${this.endpoint}/${id}/support_contracts/`,
      ...args
    )
  }

  updateSupportContracts(id, items, ...args) {
    return this.submit(
      "post",
      `/${this.endpoint}/${id}/support_contracts/`,
      items,
      ...args
    )
  }

  allProductContracts(id, ...args) {
    return this.submit(
      "get",
      `/${this.endpoint}/${id}/product_contracts/`,
      ...args
    )
  }

  updateProductContracts(id, items, ...args) {
    return this.submit(
      "post",
      `/${this.endpoint}/${id}/product_contracts/`,
      items,
      ...args
    )
  }

  allCourseContracts(id, ...args) {
    return this.submit(
      "get",
      `/${this.endpoint}/${id}/course_contracts/`,
      ...args
    )
  }

  updateCourseContracts(id, items, ...args) {
    return this.submit(
      "post",
      `/${this.endpoint}/${id}/course_contracts/`,
      items,
      ...args
    )
  }

  allMarketingActions(id, ...args) {
    return this.submit("get", `/${this.endpoint}/${id}/marketing/`, ...args)
  }

  updateMarketingActions(id, items, ...args) {
    return this.submit(
      "post",
      `/${this.endpoint}/${id}/marketing/`,
      items,
      ...args
    )
  }
}

export default CustomerProxy
